<div (click)="picker.open()">
    <mat-form-field>
        <input matInput (dateChange)="emitOnSelectedDate()" [formControl]="selectedDateFormControl" [matDatepicker]="picker"
               placeholder="Select the specific date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker disabled="false"></mat-datepicker>
    </mat-form-field>
</div>
